module.exports = __webpack_public_path__ + "img/left1.6a6c0a64.png";